import './style.scss';
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
import Isotope from 'isotope-layout';
import imagesloaded from 'imagesloaded';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

jQueryBridget('isotope', Isotope, $);
jQueryBridget( 'imagesloaded', imagesloaded, $ );
gsap.registerPlugin(ScrollTrigger);

function isoFunction() {
	const container = $('.wp-block-keztablocks-portfolio.has-masonry-grid');
	if(container.length) {
		// if($(".wp-block-keztablocks-portfolio__thumbnail.has-sh").length > 0) {
		// 	gsap.set(".wp-block-keztablocks-portfolio__thumbnail.has-sh",{height:320});
		// }
		container.imagesloaded(() => {
			container.isotope({
				itemSelector: '.has-columns-grid',
				percentPosition: true,
				masonry: {
					columnWidth: '.has-columns-grid',
					horizontalOrder: true
				}
			});
			gsap.set(container,{autoAlpha:1});
			function portFunction() {
				if($(".wp-block-keztablocks-portfolio__header-wrapper.header-animation").length) {
					$(".wp-block-keztablocks-portfolio__article").each(function() {
						var self = $(this),
							inner = self.find(".wp-block-keztablocks-portfolio__inner"),
							wrapper = self.find(".wp-block-keztablocks-portfolio__header-wrapper"),
							header = self.find(".wp-block-keztablocks-portfolio__header"),
							imgOver = self.find(".wp-block-keztablocks-portfolio__image-overlay"),
							catsWrapper = self.find(".wp-block-keztablocks-portfolio__cats-wrapper"),
							title = self.find(".wp-block-keztablocks-portfolio__title");

						let tl = gsap.timeline({paused:true});

						if(wrapper.hasClass("hover-cr")) {
							tl.fromTo(imgOver, {autoAlpha:0}, {duration: 0.3,autoAlpha:0.5})
							.fromTo(title, {xPercent:-100}, {duration: 0.3, xPercent:0}, "<")
							.fromTo(catsWrapper, {xPercent:-100}, {duration: 0.3, xPercent:0}, "<");
						} else {
							tl.fromTo(wrapper, {yPercent:100}, {duration: 0.3, yPercent:0})
							.fromTo(header, {yPercent:-100}, {duration: 0.3, yPercent:0}, "<")
							.fromTo(imgOver, {autoAlpha:0}, {duration: 0.3,autoAlpha:0.5}, "<");
						}

						inner.on("mouseenter", () => {
							tl.play();
						}).on("mouseleave", () => {
							tl.reverse();
						})
					})
				}
			}
			portFunction();

			// ScrollTrigger.refresh()
		});
	}
}
isoFunction();

function revealFunction() {
	if($(".wp-block-keztablocks-portfolio__article.anim-reveal").length) {

		gsap.set('.wp-block-keztablocks-portfolio__article.anim-reveal', {autoAlpha:1,xPercent:-100});
		gsap.set('.wp-block-keztablocks-portfolio__inner', {xPercent:100});

		ScrollTrigger.batch(".wp-block-keztablocks-portfolio__article.anim-reveal", {
		  onEnter: batch => {
		    batch.forEach((section, i) => {
		      gsap.to(section, {
		      	xPercent: 0,
		        duration: 0.6,
		        stagger: 0.1,
		        delay: i * 0.3,
		        ease: "power2.inOut"
		      });
		      gsap.to(section.querySelectorAll(".wp-block-keztablocks-portfolio__inner"), {
		        xPercent: 0,
		        duration: 0.6,
		        stagger: 0.1,
		        delay: i * 0.3,
		        ease: "power2.inOut"
		      });
		    });
		  },
  		  once: true,
		  start: "+=100 bottom",
		});
	}
}
$(window).on('load', () => {
  if($('.c-loader').length) {
    setTimeout(() => { 
          revealFunction();
      }, 3200);
  } else {
    setTimeout(() => { 
          revealFunction();
      }, 400);
  }
})